/* eslint-disable react-hooks/exhaustive-deps,react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isBrowser } from 'react-device-detect';
import PropTypes from 'prop-types';
import { useQuery } from 'react-query';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import { SendCryptoScreensFlow } from '../../constants';
import ChecklistOption from '../../../../components/Checklist';
import { GET_WHITELIST_ADDRESSES } from '../../queries';
import { tagColors, tags } from './constants';
import CurrencyIcon from '../../../../components/CurrencyIcon';
import { currencies } from '../../../../utilities/constants';
import { useLedgerFilteredCurrencies } from '../../../../utilities/sharedHooks/ledgerWallets';
import { SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY } from '../../../../utilities/sharedQueries';
import { maskCoinAddress } from '../../../../utilities/helpers';

const sortLastUsageDesc = (a, b) => (new Date(a.last_usage) < new Date(b.last_usage) ? 1 : -1);

const WhitelistManageAddresses = ({
  openScreen,
  wallet,
  ledgerAccount = null,
  isSendCryptoModal = true,
}) => {
  const { t: translate } = useTranslation();
  const { data: whitelistedAddresses, refetch: getWhitelistAddresses } = useQuery(
    [GET_WHITELIST_ADDRESSES, { coin_id: wallet?.coin_id }],
    {},
    { enabled: false }
  );

  const { data: supportedCurrencies } = useLedgerFilteredCurrencies([
    SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY,
  ]);

  useEffect(() => {
    getWhitelistAddresses();
  }, []);

  useEffect(() => {
    if (whitelistedAddresses?.length === 0 && isSendCryptoModal) {
      openScreen(SendCryptoScreensFlow.SEND_CRYPTO);
    }
  }, [whitelistedAddresses?.length]);

  const onAddNewAddress = useCallback(() => {
    if (
      (wallet &&
        supportedCurrencies &&
        supportedCurrencies[wallet?.coin] &&
        !supportedCurrencies[wallet?.coin]?.secure_funding_enabled) ||
      !ledgerAccount
    ) {
      openScreen(SendCryptoScreensFlow.WHITELIST_ADD_EXTERNAL, {
        prevScreen: SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES,
      });
    } else {
      openScreen(SendCryptoScreensFlow.WHITELIST_ADDRESS_TYPE, {
        prevScreen: SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES,
      });
    }
  }, [supportedCurrencies, ledgerAccount]);

  const deleteWhitelistedWallet = (selectedWallet, selectedWalletTag) => {
    openScreen(SendCryptoScreensFlow.WHITELIST_DELETE_ADDRESS, {
      selectedWallet,
      selectedWalletTag,
    });
  };

  const renderTitle = () => (
    <div
      className={`w-100 ${
        isBrowser ? 'd-flex align-items-center justify-content-between mb-5' : ''
      } `}>
      <div>
        <b className="text-f5 text-dark ms-2">{translate('whitelist_address_management_title')}</b>
      </div>
    </div>
  );

  const renderFooter = () => (
    <button
      onClick={onAddNewAddress}
      className="btn btn-outline-shadow text-light w-100 mt-auto"
      type="submit">
      {translate('whitelist_add_new_address')}
    </button>
  );

  return (
    <ModalBodyLayout
      onPrevClick={() => openScreen(SendCryptoScreensFlow.WHITELIST_SELECT_ADDRESS)}
      withBack={isSendCryptoModal}
      renderFooter={renderFooter}
      renderTitle={renderTitle}
      title={null}>
      <div className="d-flex flex-fill flex-column justify-content-start align-content-center h-100">
        <div>
          <div className="text-f6 text-shadow mb-3">
            {translate('whitelist_manage_title_select_another_account')}
          </div>
          <div>
            <ChecklistOption
              title={wallet?.coin?.toUpperCase()}
              value={wallet}
              onClick={() => openScreen(SendCryptoScreensFlow.WHITELIST_CHANGE_WALLET)}
              withCheckbox={false}
              className="mb-2"
              isChecked
              withArrow
              withIcon={
                <CurrencyIcon
                  currencyCode={wallet?.coin}
                  className="me-2"
                  style={{
                    width: '1.5rem',
                    height: '1.5rem',
                    ...(wallet?.coin?.toUpperCase() === currencies.XRP.icon
                      ? {
                          backgroundColor: 'white',
                          padding: '1px',
                          borderRadius: '20px',
                        }
                      : {}),
                  }}
                />
              }
            />
          </div>
        </div>
        {whitelistedAddresses?.length === 0 ? (
          <div className="d-flex flex-column justify-content-center align-items-center h-100">
            <span className="text-f4">{translate('whitelist_manage_emty_addresses')}</span>
            <span className="text-f5 text-shadow mt-2">
              {translate('whitelist_manage_emty_addresses_body')}
            </span>
          </div>
        ) : (
          <div className="mt-4">
            <div className="text-f6 text-shadow mb-3">
              {translate('whitelist_manage_title_whitelisted_addresses').replace(
                '%s',
                wallet?.coin?.toUpperCase()
              )}
            </div>
            <div>
              {whitelistedAddresses &&
                whitelistedAddresses.sort(sortLastUsageDesc).map((option) => {
                  let selectedWalletTag;
                  if (option.wallet_id) {
                    selectedWalletTag = tags.LEDGER;
                  } else {
                    selectedWalletTag = tags.EXTERNAL;
                  }

                  return (
                    <ChecklistOption
                      key={option.id}
                      title={option.name || option.coin}
                      subTitle={maskCoinAddress(option.wallet_address)}
                      value={option}
                      withCheckbox={false}
                      tag={selectedWalletTag}
                      tagColor={tagColors[selectedWalletTag]}
                      onIconClick={() => deleteWhitelistedWallet(option, selectedWalletTag)}
                      className="mb-2"
                      isChecked
                      withTrash
                    />
                  );
                })}
            </div>
          </div>
        )}
      </div>
    </ModalBodyLayout>
  );
};

export default WhitelistManageAddresses;

WhitelistManageAddresses.propTypes = {
  openScreen: PropTypes.func.isRequired,
  wallet: PropTypes.shape({
    coin: PropTypes.string.isRequired,
    coin_id: PropTypes.string.isRequired,
  }).isRequired,
  isSendCryptoModal: PropTypes.bool,
  ledgerAccount: PropTypes.object,
};
